<ng-container *ngIf="current.includes('/admin/dashboard') && currentModule">
    <div class="card">
        <h1 class="card-header">{{currentModule.descripcion_modulo}}</h1>
        <div class="card-body">{{currentModule.descripcion_larga}}</div>
    </div>
</ng-container>